import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from '@resideo/blueprint-react';
import { CountrySelectorWrapper } from '@resideo/blueprint-formik';
import useCountryStateSelector from 'hooks/useCountryStateSelector';
import { useSignUpContext } from 'routes/SignUp/context';

interface CountrySelectorFieldProps {
  value?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  error?: string | boolean;
  disabled?: boolean;
}

export const CountrySelectorField: FC<CountrySelectorFieldProps> = ({
  value,
  onChange,
  onBlur,
  error,
  disabled,
}) => {
  const { t } = useTranslation();
  const { addSignUpValues } = useSignUpContext();

  const countrySelectorState = useCountryStateSelector();

  return (
    <Box
      flex={1}
      marginBottom='medium'
      data-test-country
      className='common-input'>
      <CountrySelectorWrapper
        selectorState={countrySelectorState}
        onCountryChange={val => {
          addSignUpValues({ country: val });
          onChange(val);
        }}
        onBlur={onBlur}
        name='country'
        version='v1'
        label={t('common.countries.label')}
        value={value}
        placeholder={t('common.forms.select')}
        blankOption={t('common.forms.select')}
        initialValue={value}
        required
        disabled={disabled}
        error={error}
      />
    </Box>
  );
};
